import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  useColorScheme,
  Image,
  TouchableOpacity,
  TextInput,
  FlatList,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const CommunityFeedScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [activeTab, setActiveTab] = useState('all');
  const [posts, setPosts] = useState(mockPosts);
  const [commentText, setCommentText] = useState('');
  const [replyingTo, setReplyingTo] = useState(null);

  // 模拟点赞功能
  const handleLike = (postId) => {
    setPosts(
      posts.map((post) => {
        if (post.id === postId) {
          return {
            ...post,
            isLiked: !post.isLiked,
            likes: post.isLiked ? post.likes - 1 : post.likes + 1,
          };
        }
        return post;
      })
    );
  };

  // 模拟评论功能
  const handleComment = (postId) => {
    if (commentText.trim() === '') return;

    const newComment = {
      id: Date.now().toString(),
      userId: 'currentUser',
      username: '当前用户',
      avatar: 'https://randomuser.me/api/portraits/men/11.jpg',
      content: commentText,
      time: '刚刚',
    };

    setPosts(
      posts.map((post) => {
        if (post.id === postId) {
          return {
            ...post,
            comments: [...post.comments, newComment],
          };
        }
        return post;
      })
    );

    setCommentText('');
    setReplyingTo(null);
  };

  // 渲染不同类型的帖子内容
  const renderPostContent = (post) => {
    switch (post.type) {
      case 'food':
        return (
          <View style={{ marginBottom: 12 }}>
            <Text style={{ 
              color: isDarkMode ? '#e0e0e0' : '#4b5563', 
              marginBottom: 8,
              fontSize: 16 
            }}>
              {post.content}
            </Text>
            <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
              {post.foodImages.map((image, index) => (
                <Image
                  key={index}
                  source={{ uri: image }}
                  style={{
                    width: post.foodImages.length === 1 ? '100%' : '48%',
                    height: 160,
                    marginRight: index % 2 === 0 ? '4%' : 0,
                    marginBottom: 8,
                    borderRadius: 12,
                  }}
                />
              ))}
            </View>
            <View style={{ 
              flexDirection: 'row', 
              backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
              borderRadius: 8,
              padding: 12,
              marginTop: 8
            }}>
              <Ionicons name="nutrition" size={24} color="#0d9488" style={{ marginRight: 8 }} />
              <View>
                <Text style={{ 
                  fontWeight: 'bold', 
                  color: isDarkMode ? 'white' : '#1f2937',
                  marginBottom: 4
                }}>
                  今日营养摄入
                </Text>
                <Text style={{ color: isDarkMode ? '#e0e0e0' : '#4b5563' }}>
                  蛋白质: {post.nutrition.protein}g | 碳水: {post.nutrition.carbs}g | 脂肪: {post.nutrition.fat}g
                </Text>
              </View>
            </View>
          </View>
        );

      case 'goal':
        return (
          <View style={{ marginBottom: 12 }}>
            <Text style={{ 
              color: isDarkMode ? '#e0e0e0' : '#4b5563', 
              marginBottom: 12,
              fontSize: 16 
            }}>
              {post.content}
            </Text>
            <View style={{ 
              padding: 16,
              borderRadius: 12,
              backgroundColor: isDarkMode ? '#4b5563' : '#f0fdfa',
              borderWidth: 1,
              borderColor: isDarkMode ? '#6b7280' : '#0d948840',
            }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
                <Ionicons name="trophy" size={28} color="#0d9488" style={{ marginRight: 12 }} />
                <Text style={{ 
                  fontSize: 18, 
                  fontWeight: 'bold',
                  color: isDarkMode ? 'white' : '#0d9488'
                }}>
                  {post.goal.name}
                </Text>
              </View>
              <View style={{ marginBottom: 8 }}>
                <Text style={{ 
                  fontWeight: 'bold', 
                  color: isDarkMode ? '#e0e0e0' : '#1f2937',
                  marginBottom: 2
                }}>
                  目标详情
                </Text>
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#4b5563' }}>
                  {post.goal.description}
                </Text>
              </View>
              <View>
                <Text style={{ 
                  fontWeight: 'bold', 
                  color: isDarkMode ? '#e0e0e0' : '#1f2937',
                  marginBottom: 2
                }}>
                  完成时间
                </Text>
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#4b5563' }}>
                  {post.goal.completedAt}
                </Text>
              </View>
            </View>
          </View>
        );

      case 'exercise':
        return (
          <View style={{ marginBottom: 12 }}>
            <Text style={{ 
              color: isDarkMode ? '#e0e0e0' : '#4b5563', 
              marginBottom: 8,
              fontSize: 16 
            }}>
              {post.content}
            </Text>
            {post.exerciseImage && (
              <Image
                source={{ uri: post.exerciseImage }}
                style={{
                  width: '100%',
                  height: 200,
                  borderRadius: 12,
                  marginBottom: 12,
                }}
              />
            )}
            <View style={{ 
              backgroundColor: isDarkMode ? '#4b5563' : '#f0f7ff',
              borderRadius: 8,
              padding: 12,
            }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
                <Ionicons name="fitness" size={24} color="#2563eb" style={{ marginRight: 8 }} />
                <Text style={{ 
                  fontWeight: 'bold', 
                  color: isDarkMode ? 'white' : '#2563eb'
                }}>
                  {post.exercise.name}
                </Text>
              </View>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                <View style={{ width: '50%', marginBottom: 8 }}>
                  <Text style={{ 
                    fontSize: 13, 
                    color: isDarkMode ? '#d1d5db' : '#6b7280'
                  }}>
                    时长
                  </Text>
                  <Text style={{ 
                    fontWeight: 'bold',
                    color: isDarkMode ? 'white' : '#1f2937'
                  }}>
                    {post.exercise.duration} 分钟
                  </Text>
                </View>
                <View style={{ width: '50%', marginBottom: 8 }}>
                  <Text style={{ 
                    fontSize: 13, 
                    color: isDarkMode ? '#d1d5db' : '#6b7280'
                  }}>
                    消耗
                  </Text>
                  <Text style={{ 
                    fontWeight: 'bold',
                    color: isDarkMode ? 'white' : '#1f2937'
                  }}>
                    {post.exercise.calories} 千卡
                  </Text>
                </View>
                {post.exercise.distance && (
                  <View style={{ width: '50%', marginBottom: 8 }}>
                    <Text style={{ 
                      fontSize: 13, 
                      color: isDarkMode ? '#d1d5db' : '#6b7280'
                    }}>
                      距离
                    </Text>
                    <Text style={{ 
                      fontWeight: 'bold',
                      color: isDarkMode ? 'white' : '#1f2937'
                    }}>
                      {post.exercise.distance} 公里
                    </Text>
                  </View>
                )}
              </View>
            </View>
          </View>
        );

      default:
        return (
          <Text style={{ 
            color: isDarkMode ? '#e0e0e0' : '#4b5563', 
            marginBottom: 12,
            fontSize: 16 
          }}>
            {post.content}
          </Text>
        );
    }
  };

  // 渲染单个帖子
  const renderPost = ({ item: post }) => {
    return (
      <View style={{ 
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 16,
        padding: 16,
        marginBottom: 16,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        {/* 用户信息 */}
        <View style={{ flexDirection: 'row', marginBottom: 16 }}>
          <Image 
            source={{ uri: post.userAvatar }} 
            style={{ 
              width: 48, 
              height: 48, 
              borderRadius: 24,
              marginRight: 12, 
            }} 
          />
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ 
                fontWeight: 'bold', 
                fontSize: 16, 
                color: isDarkMode ? 'white' : '#1f2937',
                marginBottom: 2,
              }}>
                {post.username}
              </Text>
              <TouchableOpacity>
                <Ionicons name="ellipsis-horizontal" size={20} color={isDarkMode ? '#d1d5db' : '#6b7280'} />
              </TouchableOpacity>
            </View>
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280', fontSize: 14 }}>
              {post.time}
            </Text>
          </View>
        </View>
        
        {/* 帖子内容 */}
        {renderPostContent(post)}

        {/* 帖子标签 */}
        {post.tags && post.tags.length > 0 && (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 }}>
            {post.tags.map((tag, index) => (
              <View 
                key={index}
                style={{
                  backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                  borderRadius: 20,
                  marginRight: 8,
                  marginBottom: 8,
                }}
              >
                <Text style={{ 
                  fontSize: 12, 
                  color: isDarkMode ? '#e0e0e0' : '#4b5563',
                }}>
                  #{tag}
                </Text>
              </View>
            ))}
          </View>
        )}

        {/* 互动栏 */}
        <View style={{ 
          flexDirection: 'row', 
          borderTopWidth: 1, 
          borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
          paddingTop: 12,
        }}>
          <TouchableOpacity 
            style={{ 
              flexDirection: 'row', 
              alignItems: 'center', 
              marginRight: 24,
            }}
            onPress={() => handleLike(post.id)}
          >
            <Ionicons 
              name={post.isLiked ? "heart" : "heart-outline"} 
              size={22} 
              color={post.isLiked ? "#ec4899" : (isDarkMode ? '#d1d5db' : '#6b7280')} 
              style={{ marginRight: 4 }}
            />
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {post.likes}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity 
            style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
              marginRight: 24, 
            }}
            onPress={() => setReplyingTo(replyingTo === post.id ? null : post.id)}
          >
            <Ionicons 
              name="chatbubble-outline" 
              size={20} 
              color={isDarkMode ? '#d1d5db' : '#6b7280'} 
              style={{ marginRight: 4 }}
            />
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {post.comments.length}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Ionicons name="share-social-outline" size={20} color={isDarkMode ? '#d1d5db' : '#6b7280'} />
          </TouchableOpacity>
        </View>

        {/* 评论区 */}
        {post.comments.length > 0 && (
          <View style={{ marginTop: 16 }}>
            {post.comments.map((comment, index) => (
              <View 
                key={comment.id} 
                style={{ 
                  flexDirection: 'row',
                  marginBottom: 12,
                  paddingBottom: index !== post.comments.length - 1 ? 12 : 0,
                  borderBottomWidth: index !== post.comments.length - 1 ? 1 : 0,
                  borderBottomColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                }}
              >
                <Image 
                  source={{ uri: comment.avatar }} 
                  style={{ 
                    width: 36, 
                    height: 36, 
                    borderRadius: 18,
                    marginRight: 12, 
                  }} 
                />
                <View style={{ flex: 1 }}>
                  <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Text style={{ 
                      fontWeight: 'bold', 
                      fontSize: 14, 
                      color: isDarkMode ? 'white' : '#1f2937',
                      marginBottom: 2,
                    }}>
                      {comment.username}
                    </Text>
                    <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                      {comment.time}
                    </Text>
                  </View>
                  <Text style={{ color: isDarkMode ? '#e0e0e0' : '#4b5563' }}>
                    {comment.content}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        )}

        {/* 评论输入框 */}
        {replyingTo === post.id && (
          <View style={{ 
            flexDirection: 'row', 
            marginTop: 12,
            backgroundColor: isDarkMode ? '#4b5563' : '#f9fafb',
            borderRadius: 20,
            padding: 4,
          }}>
            <TextInput
              style={{ 
                flex: 1,
                fontSize: 14,
                paddingHorizontal: 12,
                paddingVertical: 8,
                color: isDarkMode ? 'white' : '#1f2937',
              }}
              placeholder="发表评论..."
              placeholderTextColor={isDarkMode ? '#d1d5db' : '#9ca3af'}
              value={commentText}
              onChangeText={setCommentText}
            />
            <TouchableOpacity 
              style={{ 
                padding: 8,
                backgroundColor: '#2563eb',
                borderRadius: 20,
              }}
              onPress={() => handleComment(post.id)}
            >
              <Ionicons name="send" size={18} color="white" />
            </TouchableOpacity>
          </View>
        )}
      </View>
    );
  };

  // 分类标签
  const renderTabs = () => {
    const tabs = [
      { id: 'all', label: '全部', icon: 'grid-outline' },
      { id: 'food', label: '饮食', icon: 'nutrition-outline' },
      { id: 'goal', label: '目标', icon: 'trophy-outline' },
      { id: 'exercise', label: '运动', icon: 'fitness-outline' },
    ];

    return (
      <View style={{ 
        flexDirection: 'row', 
        backgroundColor: isDarkMode ? '#374151' : 'white',
        padding: 8,
        borderRadius: 12,
        marginBottom: 16,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        {tabs.map((tab) => (
          <TouchableOpacity
            key={tab.id}
            style={{ 
              flex: 1,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              paddingVertical: 8,
              backgroundColor: activeTab === tab.id 
                ? (isDarkMode ? '#4b5563' : '#f0f9ff') 
                : 'transparent',
              borderRadius: 8,
            }}
            onPress={() => setActiveTab(tab.id)}
          >
            <Ionicons 
              name={tab.icon} 
              size={16} 
              color={activeTab === tab.id ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280')} 
              style={{ marginRight: 4 }}
            />
            <Text style={{ 
              fontSize: 14,
              color: activeTab === tab.id ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
              fontWeight: activeTab === tab.id ? 'bold' : 'normal',
            }}>
              {tab.label}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  };

  // 过滤帖子
  const filteredPosts = activeTab === 'all' 
    ? posts 
    : posts.filter(post => post.type === activeTab);

  return (
    <View 
      style={{ 
        flex: 1,
        backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      }}
    >
      <View style={{ padding: 16 }}>
        {renderTabs()}
        
        <FlatList
          data={filteredPosts}
          renderItem={renderPost}
          keyExtractor={(item) => item.id}
          showsVerticalScrollIndicator={false}
          ListHeaderComponent={
            <View style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
              marginBottom: 16,
            }}>
              <TouchableOpacity 
                style={{ 
                  flexDirection: 'row', 
                  alignItems: 'center',
                  flex: 1,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  borderRadius: 24,
                  padding: 12,
                  marginRight: 12,
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 1 },
                  shadowOpacity: 0.1,
                  shadowRadius: 2,
                  elevation: 2,
                }}
                onPress={() => navigation.navigate('CreatePost')}
              >
                <Image 
                  source={{ uri: 'https://randomuser.me/api/portraits/men/11.jpg' }} 
                  style={{ 
                    width: 40, 
                    height: 40, 
                    borderRadius: 20,
                    marginRight: 12, 
                  }} 
                />
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#9ca3af',
                  flex: 1,
                }}>
                  分享你的健康动态...
                </Text>
              </TouchableOpacity>
              <TouchableOpacity 
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 24,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  justifyContent: 'center',
                  alignItems: 'center',
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 1 },
                  shadowOpacity: 0.1,
                  shadowRadius: 2,
                  elevation: 2,
                }}
              >
                <Ionicons name="camera-outline" size={24} color="#2563eb" />
              </TouchableOpacity>
            </View>
          }
        />
      </View>
    </View>
  );
};

// 模拟数据
const mockPosts = [
  {
    id: '1',
    username: '李健康',
    userAvatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    time: '2小时前',
    type: 'food',
    content: '今天尝试了健康的地中海式餐食，感觉能量满满！#健康饮食 #均衡营养',
    foodImages: [
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
      'https://images.unsplash.com/photo-1498837167922-ddd27525d352?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
    ],
    nutrition: {
      protein: 28,
      carbs: 45,
      fat: 15,
    },
    tags: ['健康饮食', '均衡营养', '地中海餐'],
    likes: 24,
    isLiked: false,
    comments: [
      {
        id: 'c1',
        userId: 'user2',
        username: '营养师小王',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        content: '地中海饮食确实非常健康！富含抗氧化物质和健康脂肪，对心血管健康有很大好处。',
        time: '1小时前',
      },
      {
        id: 'c2',
        userId: 'user3',
        username: '跑步达人',
        avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
        content: '看起来很美味！能分享一下食谱吗？',
        time: '45分钟前',
      },
    ],
  },
  {
    id: '2',
    username: '小丽',
    userAvatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    time: '昨天',
    type: 'goal',
    content: '坚持一个月的低糖饮食目标终于达成啦！感谢一路上小伙伴们的支持和鼓励！',
    goal: {
      name: '30天低糖饮食挑战',
      description: '30天内控制每日糖分摄入不超过25g，培养健康饮食习惯',
      completedAt: '2023年6月20日',
    },
    tags: ['目标达成', '低糖饮食', '健康习惯'],
    likes: 56,
    isLiked: true,
    comments: [
      {
        id: 'c3',
        userId: 'user4',
        username: '糖分控制者',
        avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
        content: '恭喜你！我也在尝试控制糖分摄入，能分享一下你的经验吗？',
        time: '8小时前',
      },
    ],
  },
  {
    id: '3',
    username: '跑步达人',
    userAvatar: 'https://randomuser.me/api/portraits/men/62.jpg',
    time: '3天前',
    type: 'exercise',
    content: '今天完成了半程马拉松训练，感觉状态越来越好！#跑步 #马拉松训练',
    exerciseImage: 'https://images.unsplash.com/photo-1551927336-09d50efd69cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
    exercise: {
      name: '户外跑步',
      duration: 105,
      distance: 21.5,
      calories: 860,
    },
    tags: ['跑步', '马拉松训练', '有氧运动'],
    likes: 42,
    isLiked: false,
    comments: [
      {
        id: 'c4',
        userId: 'user5',
        username: '健身教练',
        avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
        content: '很棒的成绩！坚持就是胜利！',
        time: '2天前',
      },
      {
        id: 'c5',
        userId: 'user6',
        username: '马拉松爱好者',
        avatar: 'https://randomuser.me/api/portraits/women/14.jpg',
        content: '请问你是如何安排训练计划的？我也在准备半马。',
        time: '1天前',
      },
    ],
  },
  {
    id: '4',
    username: '营养师小王',
    userAvatar: 'https://randomuser.me/api/portraits/men/29.jpg',
    time: '一周前',
    type: 'food',
    content: '给大家分享一个高蛋白低脂的健康早餐食谱，坚持吃一个月你会发现身体的明显变化！',
    foodImages: [
      'https://images.unsplash.com/photo-1494390248081-4e521a5940db?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
    ],
    nutrition: {
      protein: 32,
      carbs: 28,
      fat: 8,
    },
    tags: ['健康早餐', '高蛋白', '营养搭配'],
    likes: 87,
    isLiked: true,
    comments: [
      {
        id: 'c6',
        userId: 'user7',
        username: '健身小明',
        avatar: 'https://randomuser.me/api/portraits/men/11.jpg',
        content: '早餐确实很重要！能详细分享一下食材和做法吗？',
        time: '5天前',
      },
    ],
  },
];

export default CommunityFeedScreen; 